import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

/* eslint no-restricted-globals:0 */
import { Component } from 'react';
import { tracker } from 'libs/common/tracker';
import TrackingContext from './TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";

class TrackingProvider extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tracker", tracker);

    _defineProperty(this, "contextValues", {
      tracker: this.tracker
    });
  }

  render() {
    return /*#__PURE__*/_jsx(TrackingContext.Provider, {
      value: this.contextValues,
      children: this.props.children
    });
  }

}

export default TrackingProvider;